import React from "react";

export function LogoutIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect opacity="0.2" x="5" y="2" width="14" height="20" fill="black" />
      <path
        d="M17 17L21 13L21 11L17 7L15.5 8.5L18 11L9 11L9 13L18 13L15.5 15.5L17 17Z"
        fill="black"
      />
    </svg>
  );
}
